import { useQuery, useMutation, useQueryClient } from 'react-query'
import client, { multipartclient, deleteclient } from './api-client'

const queryConfig = {
	staleTime: 1000 * 60 * 60,
	cacheTime: 1000 * 60 * 60,
}

async function fetchPlants(
	parcel_id,
	layer,
	date,
	evalscripturl,
	indexFilter
) {
	let url = `plants/plants_stats/?parcel_id=${parcel_id}&layer=${layer}&date=${date}&evalscripturl=${
			'' ? !evalscripturl : evalscripturl
		}&indexFilter=${indexFilter}`

	const data = await client(url)
	return data
}

export function useFetchPlants(
	parcel_id,
	layer,
	date,
	evalscripturl,
	indexFilter
) {
	return useQuery(
		['plants_stats', parcel_id, layer, date, evalscripturl, indexFilter],
		() => fetchPlants(parcel_id, layer, date, evalscripturl, indexFilter),
		{
			refetchAllOnWindowFocus: false,
			enabled:
				!!parcel_id &&
				!!layer &&
				!!date,
			...queryConfig,
		}
	)
}

async function fetchPlantsCounter(user) {
	const data = await client(`plants/plants_counter/?client_id=${user.id}`)
	return data
}

export function useFetchPlantsCounter(user) {
	return useQuery(
		['plants_stats', user.username],
		() => fetchPlantsCounter(user),
		{
			refetchAllOnWindowFocus: false,
			enabled: false,
			...queryConfig,
		}
	)
}

async function saveCrowns([layer, parcel, filter, date]) {
	const data = await client('plants/save_crowns/', {
		body: { layer: layer, parcel: parcel, filter: filter, date: date },
	})
}

export function useSaveCrownsMutation(layer, parcel, filter, date) {
	const queryClient = useQueryClient()
	return useMutation(
		(layer, parcel, filter, date) =>
			saveCrowns(layer, parcel, filter, date),
		{
			onSuccess: (data, variables) => {
				queryClient.invalidateQueries(['save_crowns', data])
			},
		}
	)
}

async function requestPlantsAnalysis([image_url, parcel_id, layer]) {
	const data = await client('plants/request_plants_analysis/', {
		body: { image_url: image_url, parcel_id: parcel_id, layer: layer },
	})
	return data
}

export function useRequestPlantsAnalysisMutation(image_url, parcel_id, layer) {
	const queryClient = useQueryClient()
	return useMutation(
		(image_url, parcel_id, layer) =>
			requestPlantsAnalysis(image_url, parcel_id, layer),
		{
			onSuccess: (data, variables) => {
				queryClient.invalidateQueries(['request_plants_analysis', data])
			},
		}
	)
}

async function savePlants([features, parcel_id]) {
	const data = await client('plants/save_plants/', {
		body: { features: features, parcel_id: parcel_id },
	})
	return data
}

export function useSavePlantsMutation() {
	const queryClient = useQueryClient()
	return useMutation(
		(features, parcel_id) => savePlants(features, parcel_id),
		{
			onSuccess: (data, variables) => {
				queryClient.invalidateQueries(['save_plants', data])
			},
		}
	)
}


async function fetchPlantByKey(
	parcel_id,
	key_id,
	layer_key,
	from_date,
	end_date
) {
	let url = `plants/?parcel_id=${parcel_id}&key=${key_id}&layer_key=${layer_key}`

	if (from_date) {
		url += `&from_date=${from_date}`
	}

	if (end_date) {
		url += `&end_date=${end_date}`
	}

	const data = await client(url)
	return data
}

export function useFetchPlantByKey(
	parcel_id,
	key_id,
	layer_key,
	from_date,
	end_date
) {
	return useQuery(
		['plants_stats', parcel_id, key_id, layer_key, from_date, end_date],
		() => fetchPlantByKey(parcel_id, key_id, layer_key, from_date, end_date),
		{
			refetchAllOnWindowFocus: false,
			enabled:
				!!parcel_id &&
				!!key_id &&
				!!layer_key &&
				!!from_date &&
				!!end_date,
			...queryConfig,
		}
	)
}

async function fetchParcelPlants(parcel_id) {
	let url = `parcels/${parcel_id}/plants/`
	const data = await client(url)
	return data
}

export function useParcelPlants(parcel_id) {
	return useQuery(
		['parcel_plants', parcel_id],
		() => fetchParcelPlants(parcel_id),
		{
			refetchAllOnWindowFocus: false,
			enabled: !!parcel_id, 
			...queryConfig,
		}
	)
}

async function saveParcelPlants(features) {
	const data = await client('plants/save_plants/', {
		body: features
	})
	return data
}

export function useParcelPlantsMutation() {
	const queryClient = useQueryClient()
	return useMutation(
		(features) => saveParcelPlants(features),
		{
			onSuccess: (data, variables) => {
				console.log('mutation', data)
				queryClient.invalidateQueries(['save_plants', data])
			},
		}
	)
}
